import { Loader2 } from "lucide-react";

// Honest progress indicator · only shows a stage when the server reports one.
export default function Thinking({ label = "Working", stage = "" }) {
  return (
    <div className="flex items-center gap-3 py-4" data-testid="thinking">
      <Loader2 className="w-8 h-8 animate-spin text-brand-magenta shrink-0" strokeWidth={1.5} />
      <div className="min-w-0">
        <div className="text-sm font-medium">{label}…</div>
        {stage && <div className="text-xs text-muted-foreground" data-testid="thinking-stage">{stage}</div>}
      </div>
    </div>
  );
}
